import { render, staticRenderFns } from "./VirtualTable.vue?vue&type=template&id=19c863d7&scoped=true"
import script from "./VirtualTable.vue?vue&type=script&lang=js"
export * from "./VirtualTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualTable.vue?vue&type=style&index=0&id=19c863d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c863d7",
  null
  
)

export default component.exports